import { Provider } from '@angular/core';

import { runOnAppInit } from '../bootstrap/bootstrapper.service';
import { TrackingCoreBootstrapService } from './tracking-core.bootstrap.service';

export function provideTracking(): Provider[] {
    return [runOnAppInit(TrackingCoreBootstrapService)];
}
